/** @jsx jsx */

import { css, jsx } from '@emotion/core';

const CloseBtn = ({
  color,
  style = {},
  onClick,
}: {
  color: string;
  style?: { [key: string]: any };
  onClick?: () => void;
}) => (
  <div
    // css={css({
    //   ':focus': {
    //     background: 'blue',
    //   },
    // })}
    style={{
      position: 'relative',
      width: 20,
      height: 20,
      transform: 'rotate(45deg)',
      cursor: 'pointer',
      ...style,
    }}
    onClick={onClick}
  >
    <div
      style={{
        position: 'absolute',
        left: 0,
        top: '50%',
        width: '100%',
        height: 1,
        background: color,
      }}
    />
    <div
      style={{
        position: 'absolute',
        left: '50%',
        top: 0,
        width: 1,
        height: '100%',
        background: color,
      }}
    />
  </div>
);

export default CloseBtn;
